import type { PRESENCE_PRESETS } from './constants';

export type PresencePreset = (typeof PRESENCE_PRESETS)[number];

export interface PresenceDefinition {
  label: string;
  icon: string;
  expectedReply: string;
  defaultExpiryHours: number;
  publicMessage: string;
}

export const PRESENCE_DEFINITIONS: Readonly<Record<PresencePreset, PresenceDefinition>> = {
  very_botherable: {
    label: 'Very Botherable',
    icon: '✦',
    expectedReply: 'Often within a few hours',
    defaultExpiryHours: 24,
    publicMessage: 'The direct line is glowing. Bothering is encouraged.',
  },
  building: {
    label: 'Building',
    icon: '◈',
    expectedReply: 'Likely later today',
    defaultExpiryHours: 24,
    publicMessage: 'The creature is making something, but your signal can still land.',
  },
  slow_replies: {
    label: 'Slow Replies',
    icon: '◔',
    expectedReply: 'Possibly within 1–2 days',
    defaultExpiryHours: 48,
    publicMessage: 'Replies are moving through cosmic syrup. Messages remain welcome.',
  },
  sleeping: {
    label: 'Sleeping',
    icon: '☾',
    expectedReply: 'After the creature resurfaces',
    defaultExpiryHours: 48,
    publicMessage: 'The creature is offline. Your transmission can wait safely here.',
  },
};
